import Pusher from 'pusher-js' // import Pusher
export default new Pusher('5ed90f97ed49ad1b9460', { cluster: 'eu', forceTLS: true })
